<template>
  <PageDialog :show="showVehicleTrack" @close="close">
    <template v-if="showVehicleTrack && vehicleDetail && vehicleDetail.isOnline && showRealTime">
      <div class="title" slot="head">实时轨迹</div>
      <RealTimeDialog
        @goHistoryTrack="goHistoryTrackHandler"
        :isPlayer="false"
        :isComponent="true"
        :isSatellite="true"
        :comDrcId="vehicleDetail.drcId"
        :comVehicleId="vehicleDetail.vehicleId"
      />
    </template>
    <template v-else-if="showVehicleTrack && vehicleDetail && !showRealTime">
      <div class="title" slot="head">历史轨迹</div>
      <VehicleTrackDialog :isArea="false" :isComponent="true" :isSatellite="true" :comDrcId="vehicleDetail.drcId" :comVehicleId="vehicleDetail.vehicleId" />
    </template>
    <template v-else>
      <div>未知状态</div>
      <div>现有条件无法判断是「实时轨迹」还是「历史轨迹」</div>
      <div>showVehicleTrack: {{ showVehicleTrack }}</div>
      <div>vehicleDetail.isOnline: {{ vehicleDetail && vehicleDetail.isOnline }}</div>
      <div>showRealTime: {{ showRealTime }}</div>
      <div>vehicleDetail: {{ !!vehicleDetail }}</div>
    </template>
    <div class="debug" style="display: none; position: absolute; left: 0; top: 0; right: 0; bottom: 0; z-index: 3000; background: #000000bf; color: #fff; padding: 20px; overflow: auto;">
      <div>showVehicleTrack: {{ showVehicleTrack }}</div>
      <div>vehicleDetail.isOnline: {{ vehicleDetail && vehicleDetail.isOnline }}</div>
      <div>showRealTime: {{ showRealTime }}</div>
      <div>
        vehicleDetail:
        <pre>{{ vehicleDetail }}</pre>
      </div>
    </div>
  </PageDialog>
</template>

<script>
import PageDialog from "./PageDialog";
import VehicleTrackDialog from "./VehicleTrack/index";
import RealTimeDialog from "./VehicleTrack/realTime";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PageDialog,
    VehicleTrackDialog,
    RealTimeDialog,
  },
  data() {
    return {
      // 显示轨迹弹框
      showVehicleTrack: false,
      // 显示实时轨迹弹框。true实时轨迹，false历史轨迹
      showRealTime: false,
    };
  },
  computed: {
    vehicleDetail() {
      let self = this;
      let detail = {
        ...(self.item || {}),
      };
      const terminalGroups = [
        detail.jobTerminalInfo,
        detail.positionTerminalInfos,
        detail.ziJiaYiTerminalInfo,
      ];
      const hasV1TerminalInfo = terminalGroups.some(Array.isArray);
      if (hasV1TerminalInfo) {
        detail.drcId = "";
        terminalGroups.some((terminals) => {
          if (!Array.isArray(terminals)) return false;
          const terminal = terminals.find(
            (item) =>
              item &&
              item.drcId !== null &&
              item.drcId !== undefined &&
              String(item.drcId).trim()
          );
          if (!terminal) return false;
          detail.drcId = String(terminal.drcId).trim();
          return true;
        });
      } else if (!detail.drcId) {
        detail.drcId = detail.positionDrcId;
        detail.drcId_ = "drcId为空用positionDrcId补上了";
        console.log("%c当前设备缺少drcId用positionDrcId补上了", 'color:#C00', detail);
      }
      return detail;
    },
  },
  watch: {
    visible(n) {
      let self = this;
      self.showVehicleTrack = n;
      self.showRealTime = !n ? null : self.vehicleDetail && !!self.vehicleDetail.isOnline;
    },
  },
  methods: {
    close() {
      let self = this;
      self.$emit("close");
    },
  },
};
</script>
